module.exports = __webpack_public_path__ + "img/img_hmi_lcd_other.4de70267.jpg";